import React from "react";

const Ttv = props => (
  <svg  width={18} height={21} viewBox="0 0 18 21" {...props}>
    <path d="M0.837487 0L0 3.4295V18.8547H3.76673V21H5.86231L7.95409 18.8547H11.304L18 11.9995V0H0.837487ZM2.51244 1.71475H16.3251V11.1421L13.3958 14.141H8.79157L6.27916 16.7131V14.141H2.51244V1.71475ZM7.11665 5.14043V10.2847H8.79157V5.14043H7.11665ZM11.7209 5.14043V10.2847H13.3958V5.14043H11.7209Z" fill="white"/>
  </svg>
);

export default Ttv;